<template>
  <component :is="tag" class="detail-empty">
    <slot>{{ text }}</slot>
  </component>
</template>

<script setup>
/**
 * Ce qui manque, dit d'une seule voix sur toutes les fiches.
 *
 * Avant lui, une valeur absente se lisait de sept façons : « — » et « - » au
 * poids d'une vraie valeur, « Non renseigné » tantôt en gras noir, tantôt en
 * gris clair, tantôt en italique, et les listes vides en phrases italiques avec
 * ou sans point, en gris ou en noir. Le lecteur ne distinguait plus « rien »
 * d'une donnée, ni une section vide d'une section qui parle d'autre chose.
 *
 * UNE VALEUR : `<DetailEmpty />` → « Non renseigné ». `DetailItem` le rend de
 * lui-même quand sa `value` est vide, et ne copie pas ce texte au clic.
 *
 * UNE SECTION OU UNE LISTE VIDE : `<DetailEmpty tag="p">Aucun matériel
 * renseigné</DetailEmpty>`. Une phrase courte, sans point final ; une seconde
 * phrase peut dire pourquoi ou quoi faire (elle, avec sa ponctuation).
 *
 * Gris tertiaire et non « muted » : #94a3b8 sur blanc tombe à 2,6:1, sous le
 * seuil de lecture — or c'est justement ce texte qu'on doit pouvoir lire pour
 * savoir ce qui reste à demander.
 */
defineProps({
  text: { type: String, default: 'Non renseigné' },
  tag: { type: String, default: 'span' },
})
</script>

<style scoped>
.detail-empty {
  margin: 0;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-normal);
  font-style: italic;
  line-height: var(--line-height-normal);
  text-transform: none;
  color: var(--color-text-tertiary);
}

p.detail-empty,
div.detail-empty {
  display: block;
}
</style>
